import { FoodSuppliers, FoodSuppliersPrams } from 'app/dataTypes/cafeteria/compensation/foodSuppliers'

import type { Request } from '../../../index'


type ResultApi = Array<{
  id: number
  title: string
  current: boolean
  public_offer_url: null | string
  privacy_consent_url: null | string
}>

export type ParamsApi = {
  student_id: number
}

export const convertParams = ({
  studentID,
}: FoodSuppliersPrams): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
  }, null]
}

export const convertResult = (apiData: ResultApi): FoodSuppliers => {
  return apiData.map(({
    id,
    title,
    current,
    public_offer_url: publicOfferURL,
    privacy_consent_url: privacyConsentURL,
  }) => {
    return ({
      ID: String(id),
      title,
      current,
      publicOfferURL: publicOfferURL || null,
      privacyConsentURL: privacyConsentURL || null,
    })
  })
}

export const GET_FOOD_SUPPLIERS: Request<FoodSuppliersPrams, FoodSuppliers, void> = [
  'cabinet/compensation/food_suppliers',
  'get',
  ['data', 'food_suppliers'],
]
